// extracted by mini-css-extract-plugin
export default {"social-share-buttons":"_23NLn","socialShareButtons":"_23NLn","social-share-group":"_2BIH0","socialShareGroup":"_2BIH0","social-share-button":"_3FsWl","socialShareButton":"_3FsWl"};